module.exports = __webpack_public_path__ + "img/mob_bg.f3a7d72d.jpg";